/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  RevokeFeatureAccessMutationRequest,
  RevokeFeatureAccessMutationResponse,
} from "../types/RevokeFeatureAccess.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const revokeFeatureAccessMutationKey = () =>
  [{ url: "/v1/access-management/revoke-feature-access" }] as const

export type RevokeFeatureAccessMutationKey = ReturnType<
  typeof revokeFeatureAccessMutationKey
>

/**
 * @summary Revoke feature access
 * {@link /v1/access-management/revoke-feature-access}
 */
export async function revokeFeatureAccess(
  data: RevokeFeatureAccessMutationRequest,
  config: Partial<RequestConfig<RevokeFeatureAccessMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    RevokeFeatureAccessMutationResponse,
    ResponseErrorConfig<Error>,
    RevokeFeatureAccessMutationRequest
  >({
    method: "POST",
    url: `/v1/access-management/revoke-feature-access`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function revokeFeatureAccessMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<RevokeFeatureAccessMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = revokeFeatureAccessMutationKey()
  return mutationOptions<
    ResponseConfig<RevokeFeatureAccessMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RevokeFeatureAccessMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return revokeFeatureAccess(data, config)
    },
  })
}

/**
 * @summary Revoke feature access
 * {@link /v1/access-management/revoke-feature-access}
 */
export function useRevokeFeatureAccess<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<RevokeFeatureAccessMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: RevokeFeatureAccessMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<RevokeFeatureAccessMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? revokeFeatureAccessMutationKey()

  const baseOptions = revokeFeatureAccessMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<RevokeFeatureAccessMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RevokeFeatureAccessMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<RevokeFeatureAccessMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RevokeFeatureAccessMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<RevokeFeatureAccessMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RevokeFeatureAccessMutationRequest },
    TContext
  >
}
